import React from 'react'
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { Container, Paper, useMediaQuery } from '@material-ui/core';
import FlexView from 'react-flexview/lib';
import Skeleton from '@material-ui/lab/Skeleton';
import { useRouteMatch, Switch, Route, useLocation, useHistory, Redirect } from 'react-router-dom';
import { isBrowser } from 'react-device-detect';
import { SessionContextStore } from '../../context/SessionContext';
import { MyDiscounts } from './MyDiscounts';
import { FlightLogs } from './FlightLogs';

export const DiscountsLayout = () => {
    const sessionContext = React.useContext(SessionContextStore)
    const isMobile = !useMediaQuery(theme => theme.breakpoints.up('md'));
    const location = useLocation()
    const history = useHistory()
    let { path, url } = useRouteMatch();

    const getTabIndex = () => {
        if(location.pathname == `${path}/my-discounts`)
            return 0
        else if(location.pathname == `${path}/flight-logs`)
            return 1
        else
            return 0
    }

    const [tabIndex, setTabIndex] = React.useState(getTabIndex());

    const handleTabChange = (event, newValue) => {
        if(newValue == 0)
            history.replace(`${path}/my-discounts`)
        else if(newValue == 1)
            history.replace(`${path}/flight-logs`)

        setTabIndex(newValue);
    };

    React.useEffect(() => {
        if(getTabIndex() != tabIndex) 
            setTabIndex(getTabIndex())
        
    }, [location.pathname])

    return (
        <Container maxWidth="lg" className="margin-top-basic">
            <FlexView hAlignContent={'center'} column={isMobile}>
                <Tabs 
                    orientation={isMobile ? "horizontal" : "vertical"}
                    variant="scrollable"
                    value={tabIndex}
                    indicatorColor={'primary'}
                    textColor="primary"
                    onChange={handleTabChange}>
                        <Tab label="My Discounts" />
                        <Tab label="Flight Logs" />
                </Tabs>
                <div className="full-width margin-left-basic margin-right-basic">
                    <Switch>
                        <Route path={`${path}/my-discounts`}>
                            {tabIndex == 0 && <Container maxWidth="lg">
                                <MyDiscounts />
                            </Container>}
                        </Route>

                        <Route path={`${path}/flight-logs`}>
                            {tabIndex == 1 && <Container maxWidth="lg">
                                <FlightLogs />
                            </Container>}
                        </Route>

                        <Redirect exact path={path} from={path} to={`${path}/my-discounts`} />
                    </Switch>
                </div>
            </FlexView>
        </Container>
    )
}